import { api } from '@/lib/api';
import type { IApiResponse, IDeployment, IDeploymentActivityRow, IDeploymentListFilters } from '@skystone/shared';
import { buildListEndpoint, fetchAllPaginated } from './list-query';

export const deploymentApi = {
  getAll: async (filters?: IDeploymentListFilters): Promise<IDeployment[]> => {
    const url = buildListEndpoint('/deployments', [
      ['productId', filters?.productId],
      ['repositoryId', filters?.repositoryId],
      ['environment', filters?.environment],
      ['deploymentStatus', filters?.deploymentStatus],
      ['from', filters?.from],
      ['to', filters?.to],
      ['includeArchived', filters?.includeArchived],
      ['limit', filters?.limit],
      ['offset', filters?.offset],
    ]);
    const result = await api.get<IApiResponse<IDeployment[]>>(url);
    return result.data;
  },

  getAllPaginated: async (filters?: Omit<IDeploymentListFilters, 'limit' | 'offset'>): Promise<IDeployment[]> =>
    fetchAllPaginated<IDeployment>('/deployments', [
      ['productId', filters?.productId],
      ['repositoryId', filters?.repositoryId],
      ['environment', filters?.environment],
      ['deploymentStatus', filters?.deploymentStatus],
      ['from', filters?.from],
      ['to', filters?.to],
      ['includeArchived', filters?.includeArchived],
    ]),

  getActivity: async (filters?: {
    from?: string;
    to?: string;
  }): Promise<IDeploymentActivityRow[]> => {
    const url = buildListEndpoint('/deployments/activity', [
      ['from', filters?.from],
      ['to', filters?.to],
    ]);
    const result = await api.get<IApiResponse<IDeploymentActivityRow[]>>(url);
    return result.data;
  },
};
